import { AppStore } from './app-store';
import { SearchStore } from './search-store';
import { ShopStore } from './shop-store';

export class RootStore {
  public appStore: AppStore;
  public searchStore: SearchStore;
  public shopStore: ShopStore;

  constructor() {
    this.appStore = new AppStore(this);
    this.searchStore = new SearchStore(this);
    this.shopStore = new ShopStore(this);
  }

  public async init() {
    await Promise.all([
      this.appStore.getUserPreferenceCookies(),
      this.appStore.getCurrencyConversions(),
      this.appStore.getMlsComplianceData(),
      this.appStore.getSubdomainData(),
      this.searchStore.loadRecentSearches(),
    ]);
  }
}
